import { ATR as defaultOptions } from "./defaultOptionsForComputation";
import { isFiniteNumber } from "../utils";

export default function () {
  let options = defaultOptions;

  function calculator(data = []) {
    const period = Math.max(1, options?.windowSize || 1);
    if (!Array.isArray(data) || data.length === 0) return [];

    const atrValues = new Array(data.length).fill(undefined);
    let prevClose;
    let prevAtr;
    let trSum = 0;
    let validCount = 0;

    for (let i = 0; i < data.length; i += 1) {
      const datum = data[i] || {};
      const high = datum.high;
      const low = datum.low;
      const close = datum.close;

      if (
        !isFiniteNumber(high) ||
        !isFiniteNumber(low) ||
        !isFiniteNumber(close)
      ) {
        prevClose = isFiniteNumber(close) ? close : prevClose;
        continue;
      }

      const rangeHighLow = high - low;
      let trueRange = rangeHighLow;

      if (isFiniteNumber(prevClose)) {
        const rangeHighClose = Math.abs(high - prevClose);
        const rangeLowClose = Math.abs(low - prevClose);
        trueRange = Math.max(rangeHighLow, rangeHighClose, rangeLowClose);
      }

      if (validCount < period) {
        trSum += trueRange;
        validCount += 1;

        if (validCount === period) {
          prevAtr = trSum / period;
          atrValues[i] = prevAtr;
        }
      } else {
        prevAtr = (prevAtr * (period - 1) + trueRange) / period;
        atrValues[i] = prevAtr;
      }

      prevClose = close;
    }

    return atrValues;
  }

  calculator.undefinedLength = function () {
    return Math.max(1, options?.windowSize || 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
